import React from 'react';

//Componente que representa el Loader (Cargando), se utiliza el componente CircularProgress de Matherial UI
const Loader = () => 
<div className="block" >
	<div className="gear"></div> 
</div>

export default Loader;